import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Typography, Grid, Card } from '@material-ui/core';
import { Author, AvatarGroupIdea } from '../../Shared';
import { IdeaCss } from '../IdeaCss';

export function IdeaInfo() {
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { ideaDetailsFlux } = useSelector(state => state.fluxIdeas);

  return (
    <>
      <Grid item xs={12}>
        <Typography className={classes.titleUpperCase}>{t('ideia_geral')}</Typography>
      </Grid>
      <Grid item xs={12} sm={8} md={8} lg={8}>
        <Card elevation={0} className={classes.card} style={{ height: '100%' }}>
          <Grid container spacing={2} className={classes.ideaGeneralField} >
            <Grid item xs={12} style={{ marginLeft: -16, marginTop: -16 }}>
              {ideaDetailsFlux.contributors.length > 0 ? (
                <AvatarGroupIdea user={ideaDetailsFlux.user} idea={ideaDetailsFlux} />
              ) : (
                <Author
                  activeUser={ideaDetailsFlux.user?.status}
                  isTimeline={true}
                  userAuthor={ideaDetailsFlux.user}
                  timelineDate={ideaDetailsFlux.timelineDate}
                />
              )}
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="subtitle2">{ideaDetailsFlux.name}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" style={{ wordWrap: 'break-word' }}>
                {ideaDetailsFlux.description}
              </Typography>
            </Grid>

            {ideaDetailsFlux?.problem && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  {t('problema_identificado')}
                </Typography>
                <Typography variant="body2"  style={{ wordWrap: 'break-word' }}>
                  {ideaDetailsFlux?.problem}
                </Typography>
              </Grid>           
            )}

            {ideaDetailsFlux?.solution && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" gutterBottom>
                  {t('solucao_proposta')}
                </Typography>
                <Typography variant="body2">
                  {ideaDetailsFlux?.solution}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Card>
      </Grid>
    </>
  );
}
